import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
export class FieldNameToControlBaseValueConverter {
    toView(definition: Array<any>, name: string) {
        if (ObjectHelper.IsNotNullAndUndefined(definition) && definition.length > 0) {
            let item = definition.filter((item) => item['ColumnName'] == name);
            return item;
        }
        return null
    }
}